/* PIXAR BLUV GT LAB PAGE - JS */

function initPixarBLUVSlider() {
  document.querySelectorAll(".gt-before-after").forEach(function(box) {
    const after = box.querySelector(".gt-after");
    const slider = box.querySelector(".gt-slider");

    if (!after || !slider) return;

    function move(event) {
      const rect = box.getBoundingClientRect();
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      const percent = (x / rect.width) * 100;

      after.style.width = percent + "%";
      slider.style.left = percent + "%";
    }

    box.addEventListener("mousemove", move);
    box.addEventListener("click", move);
    box.addEventListener("touchmove", move, { passive: true });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  initPixarBLUVSlider();
});